export default __webpack_public_path__ + "static/professional-woman-nurse-3517e93334ecbd37fed910727319f948.svg";